import React, { createContext, Dispatch, useMemo, useReducer, useState } from "react";
import { DrawerActions } from "../actions/drawerActions";
import drawerReducer, { DrawerState, initialState } from '../reducer/drawerReducer';

export interface DrawerContextInterface {
  state     : DrawerState;
  dispatch  : Dispatch<DrawerActions>;

  canViewClients: boolean,
  setCanViewClients: (value : boolean) => void,

  canViewAssignedClients: boolean,
  setCanViewAssignedClients: (value : boolean) => void,

  canViewClientSettings: boolean,
  setCanViewClientSettings: (value : boolean) => void,

  canViewIneligibleSettings: boolean,
  setCanViewIneligibleSettings: (value : boolean) => void,

  canViewFileImport: boolean,
  setCanViewFileImport: (value : boolean) => void,

  canViewReports: boolean,
  setCanViewReports: (value : boolean) => void,

  canViewLenderSettings: boolean,
  setCanViewLenderSettings: (value : boolean) => void,

  canViewUserRoles: boolean,
  setCanViewUserRoles: (value : boolean) => void,

  canViewAnalytics: boolean,
  setCanViewAnalytics: (value : boolean) => void,

  canViewAuditTrail: boolean,
  setCanViewAuditTrail: (value : boolean) => void,

  canViewExportCustomerReports: boolean,
  setCanViewExportCustomerReports: (value : boolean) => void,

  canAddEditDeleteCustomerReports: boolean,
  setCanAddEditDeleteCustomerReports: (value : boolean) => void,

  canViewPulse: boolean,
  setCanViewPulse: (value : boolean) => void
}

export const DrawerContext = createContext<DrawerContextInterface>({
  state     : initialState,
  dispatch  : () => undefined,
  canViewClients: false,
  setCanViewClients: (canViewClients) => undefined,
  canViewAssignedClients: false,
  setCanViewAssignedClients: (canViewAssignedClients) => undefined,
  canViewClientSettings: false,
  setCanViewClientSettings: (canViewClientSettings) => undefined,
  canViewIneligibleSettings: false,
  setCanViewIneligibleSettings: (canViewIneligibleSettings) => undefined,
  canViewFileImport: false,
  setCanViewFileImport: (canViewFileImport) => undefined,
  canViewReports: false,
  setCanViewReports: (canViewReports) => undefined,
  canViewLenderSettings: false,
  setCanViewLenderSettings: (canViewLenderSettings) => undefined,
  canViewUserRoles: false,
  setCanViewUserRoles: (canViewUserRoles) => undefined,
  canViewAnalytics: false,
  setCanViewAnalytics: (canViewAnalytics) => undefined,
  canViewAuditTrail: false,
  setCanViewAuditTrail: (canViewAuditTrail) => undefined,
  canViewExportCustomerReports: false,
  setCanViewExportCustomerReports: (canViewExportCustomerReports) => undefined,
  canAddEditDeleteCustomerReports: false,
  setCanAddEditDeleteCustomerReports: (canAddEditDeleteCustomerReports) => undefined,
  canViewPulse: false,
  setCanViewPulse: (canViewPulse) => undefined
});

export interface LayoutProps  { 
  children: React.ReactNode;
}

const DrawerContextProvider = (props: LayoutProps) => {
  const children = props.children;

  const [state, dispatch] = useReducer(drawerReducer, initialState);
  const [ canViewClients, setCanViewClients ] = useState<boolean>(false);
	const [ canViewClientSettings, setCanViewClientSettings ] = useState<boolean>(false);
	const [ canViewIneligibleSettings, setCanViewIneligibleSettings ] = useState<boolean>(false);
	const [ canViewFileImport, setCanViewFileImport ] = useState<boolean>(false);
	const [ canViewReports, setCanViewReports ] = useState<boolean>(false);
	const [ canViewLenderSettings, setCanViewLenderSettings ] = useState<boolean>(false);
	const [ canViewUserRoles, setCanViewUserRoles ] = useState<boolean>(false);
  const [ canViewAssignedClients, setCanViewAssignedClients ] = useState<boolean>(false);
  const [ canViewAnalytics, setCanViewAnalytics ] = useState<boolean>(false);
  const [ canViewAuditTrail, setCanViewAuditTrail ] = useState<boolean>(false);
  const [ canViewExportCustomerReports, setCanViewExportCustomerReports ] = useState<boolean>(false);
  const [ canAddEditDeleteCustomerReports, setCanAddEditDeleteCustomerReports ] = useState<boolean>(false);
  const [ canViewPulse, setCanViewPulse ] = useState<boolean>(false);

  const value = useMemo(() => ({
    state, 
    dispatch,
    canViewClients,
    setCanViewClients,
    canViewAssignedClients,
    setCanViewAssignedClients,
    canViewClientSettings,
    setCanViewClientSettings,
    canViewFileImport,
    setCanViewFileImport,
    canViewIneligibleSettings,
    setCanViewIneligibleSettings,
    canViewLenderSettings,
    setCanViewLenderSettings,
    canViewReports,
    setCanViewReports,
    canViewUserRoles,
    setCanViewUserRoles,
    canViewAnalytics,
    setCanViewAnalytics,
    canViewAuditTrail,
    setCanViewAuditTrail,
    canViewExportCustomerReports,
    setCanViewExportCustomerReports,
    canAddEditDeleteCustomerReports,
    setCanAddEditDeleteCustomerReports,
    canViewPulse,
    setCanViewPulse}), [
      state, 
      dispatch,
      canViewClients,
      setCanViewClients,
      canViewAssignedClients,
      setCanViewAssignedClients,
      canViewClientSettings,
      setCanViewClientSettings,
      canViewFileImport,
      setCanViewFileImport,
      canViewIneligibleSettings,
      setCanViewIneligibleSettings,
      canViewLenderSettings,
      setCanViewLenderSettings,
      canViewReports,
      setCanViewReports,
      canViewUserRoles,
      setCanViewUserRoles,
      canViewAnalytics,
      setCanViewAnalytics,
      canViewAuditTrail,
      setCanViewAuditTrail,
      canViewExportCustomerReports,
      setCanViewExportCustomerReports,
      canAddEditDeleteCustomerReports,
      setCanAddEditDeleteCustomerReports,
      canViewPulse,
      setCanViewPulse
    ])

  return (
    <DrawerContext.Provider value={value}>
      {
        children
      }
    </DrawerContext.Provider>
  )
}

export default DrawerContextProvider;